import { IFormatListSelectorDialogCondition, instanceOfIFormatListSelectorDialogCondition } from "./IFormatListSelectorDialogCondition";

export interface IFormatListSelectorDialogAddCondition extends IFormatListSelectorDialogCondition {
  validate: (selected?: any) => Promise<boolean>;
}
  
export function instanceOfIFormatListSelectorDialogAddCondition(instance: any): instance is IFormatListSelectorDialogAddCondition {
  return instance
    && (instance.validate !== undefined)
    && instanceOfIFormatListSelectorDialogCondition(instance);
}
